import { betaCheck, message } from "assets";

import { BetaLogo } from "components/global/Logo";
import Button from "components/global/Button";
import React from "react";
import { SelectStyle } from "./SelectAccountType";

export default function EmailVerification({ verified, emailAddress }) {
  return (
    <SelectStyle>
      {verified ? (
        <>
          <div className="allDone">
            <img className="textCenter" src={betaCheck} alt="check" />
          </div>
          <h3 className="textCenter">All done!</h3>
          <p className="textCenter colorBodyText para-mobile">
            Account set-up completed and email address verified, sign in to
            PostPaddy to start scheduling and auto publishing posts to different
            social media channels.
          </p>
          <Button
            text="Sign in to your dashboard"
            className="gotoDashboard"
            onClick={() => window.location.replace("/beta/sign-in?add_account=true")}
          />
        </>
      ) : (
        <>
          {" "}
          <div className="backNLogo">
            <BetaLogo />
          </div>
          <p className="step">
            Step 3 <span className="colorBodyText">/4</span>
          </p>
          <h1 className="center">Verify email address</h1>
          <img className="message" src={message} alt="email-verification" />
          <p className="colorBodyText l1-large center para-mobile">
            An email has been sent to{" "}
            <span className="colorSecondary">{emailAddress || "you"}</span> with
            a link to verify your account. If you don't see this mail in your
            inbox, please check your spam section.
          </p>
        </>
      )}
    </SelectStyle>
  );
}
